import { api } from "@/api";
import { UpdateBettingSelectionMappingParams, BettingSelectionMappingDto } from "@/types/ApiResponses/BettingSelection";

export const updateBettingSelectionMapping = async (
  params: UpdateBettingSelectionMappingParams
): Promise<BettingSelectionMappingDto> => {
  const { selectionId, id, ...body } = params;
  const res = await api.client.patch(`/betting-selections-new/${selectionId}/mappings/${id}`, body);
  return res.data;
};
